module.exports = __webpack_public_path__ + "static/img/zhifubiaoxian.67956d6f.png";